export enum AnimalSpecies {
  dog = 'dog',
  cat = 'cat',
  nac = 'nac',
}
